import Script from 'next/script';

import type { Nullable } from 'corgi-types';
import { getConstructorBeaconScriptOptions, serializeJS } from 'frontend-utils';

import type { ClientPageMeta } from '@utils/page-meta';

interface ConstructorBeaconProps {
  pageMeta: ClientPageMeta;
  constructorTestCell?: string;
}

export const ConstructorBeaconScript = ({
  pageMeta,
  constructorTestCell,
}: ConstructorBeaconProps) => {
  const { stage, locale, noThirdPartyScripts, crossDeviceHash } = pageMeta;

  const scriptOptions = getConstructorBeaconScriptOptions({
    stage,
    locale,
    noThirdPartyScripts,
    crossDeviceHash,
    constructorTestCell,
  });

  if (scriptOptions === null) {
    return null;
  }

  return (
    <>
      {scriptOptions?.map((scriptData, index) => (
        <Script key={index} {...scriptData?.scriptParams}>
          {scriptData?.script || ''}
        </Script>
      ))}
    </>
  );
};

export interface ConstructorDataProps {
  resultId: string;
  requestData?: Nullable<string>;
}

export const ConstructorDataScript = ({ resultId, requestData }: ConstructorDataProps) => {
  if (!resultId) {
    return '';
  }

  const serializedData = serializeJS(
    {
      result_id: resultId,
      request: requestData ? JSON.parse(requestData) : null,
    },
    { isJSON: true },
  );

  return (
    <script id="cnstrc-data" type="application/json">
      {serializedData}
    </script>
  );
};
